export const redirects = {
    lifechanger: 'https://lifechanger.sipora.io/consented?userId=',
    aca: 'https://aca.sipora.io/consented?userId=',
    cmi: 'https://cmi.sipora.io/consented?userId=',
    familyofleague: 'https://familyofleague.sipora.io/consented?userId=',
    tsb: 'https://familyofleague.sipora.io/consented?userId=',
    ecoforce: 'https://ss4h.sipora.io/consented?userId=',
    ss4h: 'https://ecoforce.sipora.io/consented?userId=',
    demo: 'https://demo.sipora.io/consented?userId=',
    standbyu: 'https://standbyu.sipora.io/consented?userId=',
    mndqld: 'https://mndqld.sipora.io/consented?userId=',
    harrysolympicdream: 'https://harrysolympicdream.sipora.io/consented?userId=',
    qldfloods: 'https://qldfloods.sipora.io/consented?userId=',
    ended: 'https://ended.sipora.io/consented?userId=',
    hearts: 'https://hearts.sipora.io/consented?userId=',
    av: 'https://av.sipora.io/consented?userId=',
    gpai: 'https://gpai.sipora.io/consented?userId=',
    da: 'https://da.sipora.io/consented?userId=',
}

export const clubIDs = {
    '66e2422d6298959464dd950d': 'https://aca.sipora.io/consented?userId=',
    '681948e933a1e2bfd0453a23': 'https://av.sipora.io/consented?userId=',
    '67047782ebcc0a0f23f30186': 'https://cmi.sipora.io/consented?userId=',
    '68d1f3f1ea49c00b40feedfe': 'https://da.sipora.io/consented?userId=',
    '64b8b26357770eea0e94b1e9': 'https://ecoforce.sipora.io/consented?userId=',
    '681978845d1f0d18cacd6d0c': 'https://ended.sipora.io/consented?userId=',
    '648a481c84c8b251f7ff46eb': 'https://gpai.sipora.io/consented?userId=',
    '67a007905ed880fa4a693a74': 'https://harrysolympicdream.sipora.io/consented?userId=',
    '680ee5c674a6b543225e41fd': 'https://hearts.sipora.io/consented?userId=',
    '678d8c16a2bd20b4d4bf4b1d': 'https://mndqld.sipora.io/consented?userId=',
    '67fc7762889af5d3b60c44a8': 'https://qldfloods2025.sipora.io/consented?userId=',
    '6530aa0f4c693de2998a3dfe': 'https://ss4h.sipora.io/consented?userId=',
    '675a1d7c301668e3a3ba84e1': 'https://standbyu.sipora.io/consented?userId=',
    '64b728dca4e64e50df3a2193': 'https://tsb.sipora.io/consented?userId=',
    '67c93f75c70b5f47e206a8e8': 'https://zambi.sipora.io/consented?userId=',
}





export const parent_clubs = {
    // include ACA as a club as well in it's parent array
 aca_clubs: [
    '66e2422d6298959464dd950d',
 ],
 lifechanger_clubs: [
    '654987321',
    '106543254'
 ],



}


